export default __webpack_public_path__ + "static/media/Diego Machado-Resume.10a52d0c.pdf";